<template>
  <div class="section grid-view" style="padding: 10px 20px">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button
              no="new"
              :disabled="!canCarrierCredit"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button no="Edit" :disabled="!canCarrierCredit" type="primary" @click="showEditDialog(false)">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <el-button no="delete" :disabled="!canCarrierCredit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="onGridReady"
        />
      </div>
    </div>
    <!--新建编辑弹窗 -->
    <cabin-carrier
      :v-if="cabinCarrierDialog.visible"
      :visible.sync="cabinCarrierDialog.visible"
      :cabin-scheme="cabinCarrierDialog.cabinScheme"
      :status.sync="cabinCarrierDialog.status"
      @func="saveTemporary"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import CabinCarrier from '@/views/cargo/v0/Information/components/partner/tab/cabinCarrier.vue'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getGridSelected } from '@/utils/agGrid'
import uidUtil from '@/utils/uidUtil'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'BookingAgentCarrierForm',
  components: { CabinCarrier, cargoAdvanceSelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        bookingAgentUuid: ''
      },
      selectedRow: null,
      selectedDataList: [],
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.rowClickedHandler,
        // 行勾选事件
        onRowSelected: this.onRowSelected
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          checkboxSelection: true,
          width: 100,
          headerCheckboxSelection: true,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false

        }, {
          headerName: this.$t('CargoMsg.Cargo_Carrier'),
          field: 'carrierStr',
          colId: 'carrierStr',
          width: 300,
          cellRenderer: (params) => {
            if (!params.value) return ''
            return this.getCarrier(params)
          },
          filterParams: {},
          filterValueGetter: params => this.getCarrier(params)
        }, {
          headerName: this.$t('Partners.carrierType'),
          field: 'carrierType',
          width: 200,
          cellRenderer: params => {
            return params.value === 0 ? this.$t('SeaExport.ShippingCompany') : this.$t('SeaExport.AirlineCompany')
          }
        }, {
          headerName: this.$t('Partners.bookingMethod'),
          field: 'bookingMode',
          width: 200,
          cellRenderer: params => {
            return params.value === 0 ? 'EDI' : (params.value === 1 ? this.$t('Partners.online') : this.$t('Partners.paper'))
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          field: 'portOfLoadingStr',
          colId: 'portOfLoadingStr',
          width: 200,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Airline'),
          field: 'airlineStr',
          colId: 'airlineStr',
          width: 200,
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.likeAirlineCode(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortStr',
          colId: 'destinationPortStr',
          width: 200,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Country'),
          field: 'countryStr',
          colId: 'countryStr',
          width: 200,
          cellRenderer: (params) => {
            if (!params.value) return ''
            return this.getCountry(params)
          },
          filterParams: {},
          filterValueGetter: params => this.getCountry(params)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Contact'),
          field: 'contact',
          colId: 'contact',
          width: 200,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContactNumber'),
          field: 'contactNumber',
          colId: 'contactNumber',
          width: 200,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: this.$t('CargoMsg.Cargo_email'),
          field: 'email',
          colId: 'email',
          width: 200,
          tooltipValueGetter: (params) => params.value
        }
      ],
      rowData: [],
      deletedBookingAgentCarrierKeys: [],
      bookingModes: [
        { label: 'EDI', value: 0 },
        { label: this.$t('Partners.online'), value: 1 },
        { label: this.$t('Partners.paper'), value: 2 }
      ],
      editDialog: {
        visible: false,
        title: '',
        initialForm: {
          uuid: '',
          branchId: '',
          carrierType: 0,
          bookingMode: '',
          carrierUuid: ' ',
          bookingAgentUuid: '',
          carrierStr: '',
          airlineStr: '',
          portOfLoadingStr: '',
          destinationPortStr: '',
          countryStr: '',
          contact: '',
          contactNumber: '',
          email: '',
          lob: ''
        },
        form: {}
      },
      cabinCarrierDialog: {
        visible: false,
        status: 'add', // add|edit
        cabinScheme: null
      },
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    canCarrierCredit() {
      return this.isEdit && this.$checkPermission(['button_SMPartner_editCarrier'])
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.filter.bookingAgentUuid = row.uuid
        this.editDialog.initialForm.branchId = row.branchId
        this.editDialog.initialForm.bookingAgentUuid = row.uuid
        this.rowData = row.bookingAgentList
        this.rowData.forEach(item => {
          if (item.carrierType === 0) {
            item.lob = SystemConstants.SE.code
          } else {
            item.lob = SystemConstants.AE.code
          }
          item.tempUuid = item.uuid
        })
        this.deletedBookingAgentCarrierKeys = []
      }
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = JSON.parse(JSON.stringify(this.editDialog.initialForm))
        this.editDialog.form.seq = this.autoIncrementNum.getNextNum()
        this.editDialog.title = this.$t('common.btn.new')
        this.cabinCarrierDialog.status = 'add'
        this.cabinCarrierDialog.cabinScheme = null
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.rowData[cell.rowIndex] : null
        if (!this.isSelect()) {
          return
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
        this.cabinCarrierDialog.status = 'edit'
        this.cabinCarrierDialog.cabinScheme = row
      }
      this.cabinCarrierDialog.visible = true
    },
    // 是否勾选
    isSelect() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return false
      }
      if (rows.length > 1) {
        this.$message.warning(this.$t('common.tips.hasOneOnly'))
        return false
      }
      return true
    },
    selectCargoItem(item) {
      this.editDialog.form[item.key] = item.value
    },
    rowClickedHandler(params) {
      this.selectedRow = params.data
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      const node = event.data
      this.selectedRow = node
    },
    getSubmitData() {
      for (const item of this.rowData) {
        if (!item.schemeCriteriaVOList) {
          item.schemeCriteriaVOList = []
        }
      }
      return {
        bookingAgentCarriers: this.rowData,
        deletedBookingAgentCarrierKeys: this.deletedBookingAgentCarrierKeys
      }
    },
    saveTemporary(data) {
      const self = this
      if (typeof data.bookingMode !== 'number') {
        this.$message.warning(this.$t('Partners.bookingMethodNotSelected'))
        return
      }
      if (!data.contact) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseAddContactPerson'))
        return
      }

      const airlineList = getCacheListByKey(basicCacheKeys.basic_data_Region)
      const airlineMap = airlineList.reduce((acc, item) => {
        acc[item.code] = item
        return acc
      }, {})

      const countryList = getCacheListByKey(basicCacheKeys.basic_data_Country)
      const countryMap = countryList.reduce((acc, item) => {
        acc[item.code] = item
        return acc
      }, {})

      let updatedRows = []
      if (this.cabinCarrierDialog.status === 'edit') {
        const row = this.rowData.find(item => (item.tempUuid === data['tempUuid']))
        if (row && row.schemeCriteriaVOList && data && data.schemeCriteriaVOList) {
          // 旧数据和新数据合并
          if (row) {
            // 将 data 值赋值给 row
            const result = this.mergeData(row.schemeCriteriaVOList, data.schemeCriteriaVOList)
            Object.assign(row, data)
            row.schemeCriteriaVOList = result
            // 确保传递的是一个包含单个对象的数组
            updatedRows = [row]
          }
        } else {
          if (row) {
            // 将 data 值赋值给 row
            Object.assign(row, data)
            // 确保传递的是一个包含单个对象的数组
            updatedRows = [row]
          }
        }
      } else {
        updatedRows = [data]
      }
      this.setFormString(updatedRows[0], 'carrierStr', SystemConstants.CARRIER.code, true)
      this.setFormString(updatedRows[0], 'portOfLoadingStr', SystemConstants.POL.code)
      this.setFormString(updatedRows[0], 'destinationPortStr', SystemConstants.POD.code)
      this.setFormString(updatedRows[0], 'airlineStr', SystemConstants.REGION.code, airlineMap)
      this.setFormString(updatedRows[0], 'countryStr', SystemConstants.COUNTRY.code, countryMap)

      if (this.cabinCarrierDialog.status === 'add') {
        const resultStr = this.generateRowString(updatedRows[0])
        for (const rowDatum of this.rowData) {
          const rowDataStr = this.generateRowString(rowDatum)
          if (resultStr === rowDataStr) {
            this.$message.warning(this.$t('CargoMsg.Cargo_AlreadyExistsCheck'))
            return
          }
        }
        updatedRows[0].tempUuid = uidUtil.createUID()
        this.rowData.push(updatedRows[0])
      } else {
        const row = this.rowData.find(item => (item.tempUuid === data['tempUuid']))
        const resultStr = this.generateRowString(updatedRows[0])
        for (const rowDatum of this.rowData) {
          const rowDataStr = this.generateRowString(rowDatum)
          if (rowDatum.tempUuid !== row.tempUuid && resultStr === rowDataStr) {
            this.$message.warning(this.$t('CargoMsg.Cargo_AlreadyExistsCheck'))
            return
          }
        }
        this.gridOptions.api.updateRowData({ update: updatedRows })
        // 刷新表格数据
        this.gridOptions.api.refreshCells({ force: true })
      }
      self.cabinCarrierDialog.visible = false
    },
    mergeData(oldData, newData) {
      const result = []
      // 先处理 newData 中的数据
      newData.forEach(newRow => { result.push(newRow) })
      // 处理 oldData 中未被覆盖的数据
      oldData.forEach(oldRow => {
        const newRow = newData.find(newRow => newRow.criteriaValue === oldRow.criteriaValue)
        if (!newRow) {
          // 如果 oldData 中的数据在 newData 中不存在
          result.push(oldRow)
        }
      })
      return result
    },
    setFormString(data, key, criteriaType, map) {
      if (!data.schemeCriteriaVOList || data.schemeCriteriaVOList.length === 0) {
        data[key] = ''
        return
      }
      let filteredData = data.schemeCriteriaVOList.filter(item => (item.criteriaType === criteriaType && (item.waitDealStatus === 'add' || !item.waitDealStatus)))
      if (!filteredData || filteredData.length === 0) {
        data[key] = ''
        return
      }
      filteredData = this.sortAddRow(filteredData)
      if (filteredData.length > 0) {
        const resultStr = filteredData.map(item => item.criteriaValue).join(',')
        data[key] = resultStr || ''
      }
    },
    sortAddRow(data) {
      return data.sort((a, b) => {
        const valueA = String(a.criteriaValue)
        const valueB = String(b.criteriaValue)
        return valueA.localeCompare(valueB)
      })
    },
    generateRowString(data) {
      return data.carrierStr + data.portOfLoadingStr + data.airlineStr + data.destinationPortStr + data.countryStr + data.contact
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridApi.sizeColumnsToFit()
    },
    remove() {
      const self = this
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const seqs = rows.map(row => row.seq)
        this.rowData = this.rowData.filter(p => !seqs.includes(p.seq))
        for (const item of rows) {
          if (item.uuid) {
            this.deletedBookingAgentCarrierKeys.push(item.uuid)
          }
        }
      }).catch(() => { })
    },
    getCarrier(params) {
      const carrierIds = params.data.carrierStr.split(',')
      let tmpData
      if (params.data.carrierType === 0) {
        tmpData = { lob: SystemConstants.SE.code }
      } else {
        tmpData = { lob: SystemConstants.AE.code }
      }
      const labels = carrierIds.map(carrierId => ColumnUtils.carrierLabelFunc(tmpData, Number(carrierId)))
      return labels ? labels.join(',') : ''
    },
    getCountry(params) {
      const countryCodes = params.data.countryStr.split(',')
      const labels = countryCodes.map(countryCode => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', countryCode, 'code'))
      return labels ? labels.join(',') : ''
    }
  }
}
</script>

<style>
</style>
